module.exports = __webpack_public_path__ + "img/productHSE_14.d64809fe.png";